import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import CustomTable from "../../common/CustomTable";

import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";

import { replaceUrlParam } from "../../common/utils";

import {
  fetchProductsOrdered,
  selectReports,
  fetchMoreProductsOrdered,
  getFullListProductsOrdered,
} from "./reportsSlice";

import {
  selectBrands,
  fetchBrands,
  getFullList as getFullBrandsList,
} from "../brands/brandsSlice";
import {
  selectSuppliers,
  fetchSuppliers,
  getFullList as getFullSuppliersList,
} from "../suppliers/suppliersSlice";
import {
  selectClients,
  fetchClients,
  getFullList as getFullClientsList,
} from "../clients/clientsSlice";
import {
  selectCategories,
  fetchCategoriesTree,
} from "../categories/categoriesSlice";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexFlow: "column",
  },
}));

export default function ProductsOrdered(props) {
  const history = useHistory();

  const headCells = [
    // {
    //   id: 'images',
    //   checked: true,
    //   numeric: false,
    //   sortable: false,
    //   disablePadding: false,
    //   label: 'Image',
    //   long: false,
    // },
    {
      id: "numberOfOrders",
      checked: true,
      numeric: false,
      sortable: true,
      disablePadding: false,
      label: "Orders",
      long: false,
    },
    {
      id: "sku",
      checked: true,
      numeric: false,
      sortable: true,
      disablePadding: false,
      label: "SKU",
      long: false,
    },
    {
      id: "name",
      checked: true,
      numeric: false,
      sortable: true,
      disablePadding: false,
      label: "Product Name",
      long: false,
    },
    {
      id: "supplierName",
      checked: true,
      numeric: false,
      sortable: true,
      disablePadding: false,
      label: "Supplier",
      long: false,
    },
    // {
    //   id: 'categories',
    //   checked: true,
    //   numeric: false,
    //   sortable: false,
    //   disablePadding: false,
    //   label: 'Categories',
    //   long: true,
    // },

    {
      id: "brandName",
      checked: true,
      numeric: false,
      sortable: true,
      disablePadding: false,
      label: "Brand",
      long: false,
    },
    {
      id: "rrp",
      checked: true,
      numeric: true,
      sortable: true,
      disablePadding: false,
      label: "RRP",
      long: false,
    },
    {
      id: "costPrice",
      checked: true,
      numeric: true,
      sortable: true,
      disablePadding: false,
      label: "Cost Price",
      long: false,
    },
    {
      id: "sellingPrice",
      checked: true,
      numeric: true,
      sortable: true,
      disablePadding: false,
      label: "Selling Price",
      long: false,
    },
    {
      id: "freight",
      checked: true,
      numeric: true,
      sortable: true,
      disablePadding: false,
      label: "Freight",
      long: false,
    },

    {
      id: "margin",
      checked: true,
      numeric: true,
      sortable: true,
      disablePadding: false,
      label: "Margin (%)",
      long: false,
    },
    // {
    //   id: 'updatedAt',
    //   checked: true,
    //   numeric: true,
    //   disablePadding: false,
    //   label: 'Last Updated',
    //   long: false,
    //   sortable: true,
    //   dates: true
    // },
    // {
    //   id: 'createdAt',
    //   checked: true,
    //   numeric: true,
    //   disablePadding: false,
    //   label: 'Created',
    //   long: false,
    //   sortable: true,
    //   dates: true
    // },
    {
      id: "statusID",
      checked: true,
      numeric: true,
      sortable: true,
      disablePadding: false,
      label: "Status",
      long: false,
    },
  ];

  const cellList = headCells.map((cell) => {
    return cell.id;
  });
  const [rowList, setRowList] = useState([...headCells]);

  let jwtToken = localStorage.getItem("coreToken");
  const dispatch = useDispatch();
  const classes = useStyles();
  const { loading, reportList, productsOrderedAmount, lastQuery } =
    useSelector(selectReports);

  // const edit = props.location.pathname.includes('edit');
  const [brandNames, setBrandNames] = useState([]);
  const [brandIDs, setBrandIDs] = useState([]);
  const [supplierIDs, setSupplierIDs] = useState([]);
  const [supplierNames, setSupplierNames] = useState([]);
  const [clientIDs, setClientIDs] = useState([]);
  const [clientNames, setClientNames] = useState([]);
  const [statusIDs, setStatusIDs] = useState([]);

  const [checked, setCategoriesChecked] = useState([]);

  const [numberShown, setNumberShown] = useState(25);
  const [moreProducts, setMoreProducts] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [sortProperty, setSortProperty] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  const [dateBefore, setDateBefore] = useState("");
  const [dateAfter, setDateAfter] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const { brandsList, brandsAmount } = useSelector(selectBrands);
  const { suppliersList, suppliersAmount } = useSelector(selectSuppliers);
  const { clientsList, clientsAmount } = useSelector(selectClients);
  const { categoriesTree } = useSelector(selectCategories);

  useEffect(() => {
    if (!brandsList.length) {
      dispatch(fetchBrands({ token: jwtToken, query: "" }));
    }
    if (!suppliersList.length) {
      dispatch(fetchSuppliers({ token: jwtToken, query: "" }));
    }

    dispatch(
      fetchCategoriesTree({
        token: jwtToken,
      })
    );

    dispatch(fetchClients({ token: jwtToken, query: "" }));
  }, [dispatch]);

  const handleBrandsChange = (event) => {
    let idsArr = [];
    event.target.value.forEach((selected) => {
      let selectedBrand = brandsList.filter((brand) => brand.name === selected);
      selectedBrand[0] && idsArr.push(selectedBrand[0].id);
    });
    setBrandNames(event.target.value);
    setBrandIDs(idsArr);
  };

  const handleSupplierChange = (event) => {
    let idsArr = [];
    event.target.value.forEach((selected) => {
      let selectedSupplier = suppliersList.filter(
        (supplier) => supplier.name === selected
      );
      selectedSupplier[0] && idsArr.push(selectedSupplier[0].id);
    });

    setSupplierNames(event.target.value);
    setSupplierIDs(idsArr);
  };

  const handleClientChange = (event) => {
    let idsArr = [];
    event.target.value.forEach((selected) => {
      let selectedClient = clientsList.filter(
        (client) => client.name === selected
      );
      selectedClient[0] && idsArr.push(selectedClient[0].id);
    });

    setClientNames(event.target.value);
    setClientIDs(idsArr);
  };

  useEffect(() => {
    let searchQuery = lastQuery ? lastQuery : "";

    if (rowsPerPage) {
      searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);
    }
    dispatch(
      fetchProductsOrdered({
        token: jwtToken,
        query: lastQuery ? searchQuery : `?limit=${rowsPerPage}`,
      })
    );

    setNumberShown(rowsPerPage);
  }, [dispatch, rowsPerPage]);

  const getFullListTrigger = () => {
    let searchQuery = lastQuery ? lastQuery : "";
    searchQuery = replaceUrlParam(searchQuery, "limit", 100);

    dispatch(
      getFullListProductsOrdered({
        token: jwtToken,
        offset:
          rowsPerPage > reportList.length ? rowsPerPage : reportList.length,
        query: searchQuery,
        targetLength: productsOrderedAmount,
      })
    );
  };

  const [ready, setReady] = useState(false);
  if (loading === "loaded" && !ready) {
    setReady(true);
  }

  const handleMore = (e, page) => {
    if (page < currentPage) {
      setCurrentPage(page);
      setNumberShown((page + 1) * rowsPerPage);
    } else {
      let expectedLen = (page + 1) * rowsPerPage;
      if (
        reportList.length < productsOrderedAmount &&
        reportList.length < expectedLen
      ) {
        dispatch(
          fetchMoreProductsOrdered({
            token: jwtToken,
            query: lastQuery,
            offset: numberShown,
          })
        );
      } else if (reportList.length == productsOrderedAmount) {
        setMoreProducts(false);
      }
      setCurrentPage(currentPage + 1);
      setNumberShown((currentPage + 2) * rowsPerPage);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = sortProperty === property && sortDirection === "asc";
    setSortDirection(isAsc ? "desc" : "asc");
    setSortProperty(property);
    switch (property) {
      case "updatedAt":
        property = "updated_at";
        break;
      case "createdAt":
        property = "created_at";
        break;
      case "statusID":
        property = "status_id";
        break;
      case "supplierName":
        property = "supplier_name";
        break;
      case "brandName":
        property = "brand_name";
        break;
      case "rrp":
        property = "rrp_margin";
        break;
      case "costPrice":
        property = "cost_price";
        break;
      case "sellingPrice":
        property = "selling_price";
        break;
    }

    let searchQuery = lastQuery ? lastQuery : "";

    if (property) {
      searchQuery = replaceUrlParam(searchQuery, "order_by", property);
    }
    searchQuery = replaceUrlParam(searchQuery, "sort", isAsc ? "desc" : "asc");
    searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);

    dispatch(
      fetchProductsOrdered({
        token: jwtToken,
        query: searchQuery,
      })
    );
  };

  const handleSearch = () => {
    let daterange = "";
    if (dateBefore && dateAfter) {
      daterange = `${dateAfter.toISOString().substring(0, 10)},${dateBefore
        .toISOString()
        .substring(0, 10)}`;
    } else if (dateBefore && !dateAfter) {
      daterange = `lte,${dateBefore.toISOString().substring(0, 10)}`;
    } else if (!dateBefore && dateAfter) {
      daterange = `gte,${dateAfter.toISOString().substring(0, 10)}`;
    }

    let searchQuery = lastQuery ? lastQuery : "";

    if (statusIDs.length) {
      searchQuery = replaceUrlParam(
        searchQuery,
        "statuses",
        statusIDs.join(",")
      );
    }

    searchQuery = replaceUrlParam(searchQuery, "categories", checked.join(","));

    searchQuery = replaceUrlParam(searchQuery, "brands", brandIDs.join(","));

    if (supplierIDs.length) {
      searchQuery = replaceUrlParam(
        searchQuery,
        "suppliers",
        supplierIDs.join(",")
      );
    }
    if (clientIDs.length) {
      searchQuery = replaceUrlParam(searchQuery, "clients", clientIDs.join(","));
    }
    if (daterange) {
      searchQuery = replaceUrlParam(searchQuery, "odate", daterange);
    }
    if (searchTerm) {
      searchQuery = replaceUrlParam(searchQuery, "name", searchTerm);
    }

    console.log("searchQuery", searchQuery);
    dispatch(
      fetchProductsOrdered({
        query: searchQuery,
        token: jwtToken,
      })
    );
    setCurrentPage(0);
  };

  const handleClear = () => {
    setBrandNames([]);
    setBrandIDs([]);
    setSupplierNames([]);
    setSupplierIDs([]);
    setClientNames([]);
    setClientIDs([]);
    setSearchTerm("");
    setDateBefore("");
    setDateAfter("");
    setSortDirection(null);
    setSortProperty(null);

    dispatch(
      fetchProductsOrdered({
        token: jwtToken,
        query: `?limit=${rowsPerPage}`,
      })
    );
    setCurrentPage(0);
  };

  const handleEditClick = (id) => {
    // dispatch(
    //   fetchProductByID({
    //     token: jwtToken,
    //     id: id,
    //   })
    // );
    // history.push('/products/edit');
  };

  let content;
  const actionsHandleChange = [
    handleBrandsChange,
    handleSupplierChange,
    handleClientChange,
  ];
  const actionsNames = [brandNames, supplierNames, clientNames];
  const actionsLists = [brandsList, suppliersList, clientsList];
  const selectNames = ["brand", "supplier", "client"];

  if (loading === "loading") {
    content = (
      <CircularProgress className={classes.progress} color="secondary" />
    );
  } else if (loading === "loaded") {
    let options = {
      timeZone: "Australia/Sydney",
    };

    content = (
      <CustomTable
        actionsLists={actionsLists}
        actionsHandleChange={actionsHandleChange}
        actionsNames={actionsNames}
        data={reportList}
        headCells={headCells}
        cellList={cellList}
        handleSearch={handleSearch}
        handleClear={handleClear}
        setSearchTerm={setSearchTerm}
        searchTerm={searchTerm}
        handleEditClick={handleEditClick}
        area={"productsOrdered"}
        selectNames={selectNames}
        setDateBefore={setDateBefore}
        setDateAfter={setDateAfter}
        dateAfter={dateAfter}
        dateBefore={dateBefore}
        noChecks={true}
        rowList={rowList}
        setRowList={setRowList}
        productsAmount={productsOrderedAmount}
        handleMore={handleMore}
        page={currentPage}
        setPage={setCurrentPage}
        handleRequestSort={handleRequestSort}
        sortProperty={sortProperty}
        sortDirection={sortDirection}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        getFullList={getFullListTrigger}
      />
    );
  }
  // else if (loading === 'error') {
  //   content = <Error error={{message: 'Something went wrong'}} />;
  // }

  return (
    <Grid
      container
      spacing={3}
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
      style={{ height: "100%" }}
    >
      {content}
    </Grid>
  );
}
